// React pages shown in the browser.


import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LoginGateway from "./pages/LoginGateway";
import EmployeeLogin from "./pages/EmployeeLogin";
import AddEmployee from "./pages/AddEmployee"; // Import the page using its direct path
import AdminSignup from "./pages/AdminSignup";
import EmployeeMap from "./pages/EmployeeMap";
import ActivityPage from "./pages/ActivityPage";
import '@fortawesome/fontawesome-free/css/all.min.css';
import EmployeeDashboard from "./pages/EmployeeDashboard";
import EmployeesPage from "./pages/EmployeesPage";
import SchedulerPage from "./pages/SchedulerPage";
import AddClient from "./pages/AddClient";
import EmployeeHistory from './pages/EmployeeHistory';
import PayrollUpload from './pages/PayrollUpload';
import PayrollManager from './pages/PayrollManager';
import Logout from "./pages/Logout";
import { APIProvider } from "@vis.gl/react-google-maps";
import fetchBase from "./utils/fetchBase";
import ClientsPage from "./pages/ClientsPage";
import OuraHome from "./pages/OuraHome";
import BlogPost from "./pages/BlogPost";
import MyPassedShifts from "./pages/MyPassedShifts.jsx"
import ApplicationsPage from "./pages/ApplicationsPage";
import ApplyPage from "./pages/ApplyPage";
import EmployeeManual from "./pages/EmployeeManual";
import DocumentHubPage from "./pages/DocumentHubPage";
import AdminNotificationsPage from "./pages/AdminNotificationsPage";
import DocumentSectionPage from "./pages/DocumentSectionPage";
import DocumentListPage from "./pages/DocumentListPage";
import HubDocumentViewerPage from "./pages/HubDocumentViewerPage";
import HubWordViewerPage from "./pages/HubWordViewerPage";
import AdminRegistrationClosed from "./pages/AdminRegistrationClosed";
import Ourademo from "./pages/Ourademo";
import EmployeeNotificationsPage from "./pages/EmployeeNotificationsPage";
import EmployeeDocumentHubPage from "./pages/EmployeeDocumentHubPage";
import EmployeeDocumentViewerPage from "./pages/EmployeeDocumentViewerPage";
import AdminProfilePage from "./pages/AdminProfilePage";
import AADevine from "./pages/AADevine";

function App() {
    return (
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
        <Router>
            <Routes>
                <Route path="/account/profile" element={<AdminProfilePage />} />

                <Route path="/employee/notifications" element={<EmployeeNotificationsPage />} />

                <Route path="/employee/document-hub/documents/:documentId" element={<EmployeeDocumentViewerPage />} />

                <Route path="/employee/document-hub" element={<EmployeeDocumentHubPage />} />

                <Route path="/notifications" element={<AdminNotificationsPage />} />

                <Route path="/admin/register" element={<AdminRegistrationClosed />} />
                <Route path="/demo" element={<Ourademo />} />

                <Route path="/employee/manual" element={<EmployeeManual />} />
                <Route path="/document-hub" element={<DocumentHubPage />} />
                <Route path="/document-hub/:hubId" element={<DocumentSectionPage />} />
                <Route path="/document-hub/:hubId/sections/:sectionId" element={<DocumentListPage />} />
                <Route path="/document-hub/:hubId/sections/:sectionId/documents/:documentId" element={<HubDocumentViewerPage />} />
                <Route path="/document-hub/:hubId/sections/:sectionId/documents/:documentId/word" element={<HubWordViewerPage />} />

                <Route path="/applications" element={<ApplicationsPage />} />

                <Route path="/apply" element={<ApplyPage />} />

                <Route path="/partners/aa-devine" element={<AADevine />} />

                <Route path="/employee/history" element={<MyPassedShifts />} />
                {/* View / manage clients for admin(s) */}
                <Route path="/admin/clients" element={<ClientsPage />} />

                <Route path="/logout" element={<Logout />} />

                <Route path="/admin/payroll" element={<PayrollManager />} />
                {/* Upload page for payroll master sheet */}
                <Route
                    path="/payroll/upload"
                    element={<PayrollUpload onUploadSuccess={async () => {
                        await fetch(`${fetchBase}/api/payroll/generate-template`, {
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer " + localStorage.getItem("jwt_token"),
                            }
                        });

                        window.location.href = "/admin/payroll?tab=live";
                    }}
                    />}
                />

                {/* View employee visit logs */}
                <Route path="/employee-history" element={<EmployeeHistory />} />

                {/* Add new client (admin only) */}
                <Route path="/addclient" element={<AddClient />} />

                {/* Scheduler calendar for assigning shifts */}
                <Route path="/scheduler" element={<SchedulerPage />} />
                // Route path ="/url" (when the browser matches /url, open the SchedulerPage.jsx Component)

                {/* View all employees added by admin */}
                <Route path="/employees" element={<EmployeesPage />} />

                {/* Employee dashboard after successful login */}
                <Route path="/employee/dashboard" element={<EmployeeDashboard />} />

                {/* Activity dashboard for real-time clock-in status */}
                <Route path="/activity" element={<ActivityPage />} />

                {/* Form to add a new employee. */}
                {/* This shows a React page or component at the URL http://localhost:3000/addemployee*/}
                <Route path="/addemployee" element={<AddEmployee />} />

                {/* Employee map view with geolocation */}
                <Route path="/employee-map" element={<EmployeeMap />} />

                {/* Employee login page */}
                <Route path="/employee/login" element={<EmployeeLogin />} />

                {/* Homepage (OuraHome) — no sidebar or nav bar */}
                <Route path="/login" element={<LoginGateway />} />

                <Route path="/" element={<LoginGateway />} />

                <Route path="/marketing-page" element={<OuraHome />} />

                {/* Admin signup page */}
                <Route path="/admin/signup" element={<AdminSignup />} />

                {/* Admin login page — no sidebar */}
                <Route path="/admin/login" element={<AdminLogin />} />

                {/* Admin dashboard page — custom Apple-style nav bar included in component */}
                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                {/*Blog post*/}
                <Route path="/insights/:slug" element={<BlogPost />} />

                <Route path="/blog/:slug" element={<BlogPost />} />

                {/* Optional internal admin pages (with sidebar) — if still needed */}
                <Route
                    path="/dashboard"
                    element={
                        <div style={{ display: "flex" }}>
                            <Sidebar />
                            <div style={{ marginLeft: "220px", padding: "20px" }}>
                                <Dashboard />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/reports"
                    element={
                        <div style={{ display: "flex" }}>
                            <Sidebar />
                            <div style={{ marginLeft: "220px", padding: "20px" }}>
                                <Reports />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/settings"
                    element={
                        <div style={{ display: "flex" }}>
                            <Sidebar />
                            <div style={{ marginLeft: "220px", padding: "20px" }}>
                                <Settings />
                            </div>
                        </div>
                    }
                />
            </Routes>
        </Router>
    </APIProvider>
    );
}

export default App;